"use client";

import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterQuickLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-secondary-foreground/10 animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-3 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start px-0 py-0 text-sm text-secondary-foreground/70 hover:text-primary hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent h-auto font-normal transition-colors">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const equipmentLinks = [{
    label: "Skid Steer Loaders",
    href: "/EquipmentPage"
  }, {
    label: "Compact Backhoes",
    href: "/EquipmentPage"
  }, {
    label: "Mini Excavators",
    href: "/EquipmentPage"
  }, {
    label: "Compact Wheel Loaders",
    href: "/EquipmentPage"
  }];
  return <footer id="footer" className="bg-secondary text-secondary-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <span className="text-xl font-bold tracking-tight text-secondary-foreground">
                Lynx Services
              </span>
            </Link>
            <p className="text-sm text-secondary-foreground/70 leading-relaxed max-w-xs">
              Providing reliable grading services and well-maintained rental
              equipment for professionals, contractors, and engineers.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-secondary-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterQuickLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-secondary-foreground">
              Equipment
            </h3>
            <NavigationMenu viewport={false} className="max-w-full justify-start">
              <NavigationMenuList className="flex-col items-start gap-3 space-x-0">
                {equipmentLinks.map((link, i) => <NavigationMenuItem key={i} data-index={i} className="w-full">
                    <NavigationMenuLink asChild className="w-full justify-start px-0 py-0 text-sm text-secondary-foreground/70 hover:text-primary hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent h-auto font-normal transition-colors">
                      <Link to={link.href}>{link.label}</Link>
                    </NavigationMenuLink>
                  </NavigationMenuItem>)}
              </NavigationMenuList>
            </NavigationMenu>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-secondary-foreground">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4 text-sm text-secondary-foreground/70">
              <li className="flex items-center gap-3">
                <Phone className="size-5 text-primary shrink-0" />
                <span>(623) 268 8618</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-primary shrink-0" />
                <span>hector@lynxservices.us</span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-secondary-foreground/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-secondary-foreground/60 text-center md:text-left">
            &copy; {new Date().getFullYear()} Lynx Rentals. All rights reserved.
          </p>
          <div className="flex items-center gap-2 bg-secondary-foreground/5 px-3 py-1.5 rounded-lg border border-secondary-foreground/10 shadow-sm">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-lg h-2.5 w-2.5 bg-green-500"></span>
            </span>
            <span className="text-xs font-medium text-secondary-foreground/80 tracking-wide uppercase">
              Service Status: Online
            </span>
          </div>
        </div>
      </div>
    </footer>;
}